// extracted by mini-css-extract-plugin
export default {"item":"Item_item__SfiSD","icon":"Item_icon__5lOtV","selected":"Item_selected__FroGx","title":"Item_title__nT-81"};